import { render, staticRenderFns } from "./User_Data.vue?vue&type=template&id=53eb211c&scoped=true&"
import script from "./User_Data.vue?vue&type=script&lang=js&"
export * from "./User_Data.vue?vue&type=script&lang=js&"
import style0 from "./User_Data.vue?vue&type=style&index=0&id=53eb211c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb211c",
  null
  
)

export default component.exports